/**
 * Structural presentation archetypes — different IA, navigation, and framing (not just colors).
 * Inspired by different product patterns common in trading / analytics tools.
 */
export type ShellLayoutId =
  | 'classic-rail' /** Bloomberg-style: vertical category rail + canvas */
  | 'top-deck' /** Trading terminal strip: category + tool as control strips above canvas */
  | 'three-inspector' /** IDE-style: narrow tree | canvas | context / quick-inspector */
  | 'bottom-dock' /** Mobile-first desk: primary workspace with tool dock along bottom */
  | 'drawer-bleed' /** Chart-first: full-bleed canvas; tools in slide-over drawer */
  | 'category-lanes' /** Discovery: horizontal “shelves” per category (media-library pattern) */
  | 'icon-rail' /** Figma-like: ultra-narrow icon rail; labels in tooltip-style overflow */
  | 'workspace-tabs' /** Linear-style: top tab strip = tools; deep work in canvas */
  | 'split-deck' /** Double header: global controls + second row = tool context */
  | 'bento-pick' /** Notion / bento: category tiles then tool tiles before canvas */;

/** One full cycle — 30 concepts map by concept index % length (see registry). */
export const SHELL_LAYOUT_CYCLE: readonly ShellLayoutId[] = [
  'classic-rail',
  'top-deck',
  'three-inspector',
  'bottom-dock',
  'drawer-bleed',
  'category-lanes',
  'icon-rail',
  'workspace-tabs',
  'split-deck',
  'bento-pick',
  // second pass — same structures, different concept still changes palette + copy + quick order
  'drawer-bleed',
  'classic-rail',
  'three-inspector',
  'bottom-dock',
  'top-deck',
  'category-lanes',
  'bento-pick',
  'icon-rail',
  'workspace-tabs',
  'split-deck',
  // third pass — completes 30 slots
  'three-inspector',
  'bottom-dock',
  'drawer-bleed',
  'classic-rail',
  'top-deck',
  'category-lanes',
  'workspace-tabs',
  'icon-rail',
  'split-deck',
  'bento-pick',
] as const;

export function shellLayoutForConceptIndex(index: number): ShellLayoutId {
  return SHELL_LAYOUT_CYCLE[index % SHELL_LAYOUT_CYCLE.length];
}
